import React, { Fragment, useMemo } from 'react'
import Scrollbar from 'react-perfect-scrollbar'
import { navigations } from 'app/navigations'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import useSettings from 'app/hooks/useSettings'
import { useSelector } from 'react-redux'
import { allFlags } from 'app/ducks/featureFlags/selectors'
import MatxVerticalNav from '../MatxVerticalNav/MatxVerticalNav'
import { shouldRenderNavigation } from 'app/navigation/shouldRenderNavigation'

const useStyles = makeStyles(({ palette, ...theme }) => ({
  scrollable: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  sidenavMobileOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100vw',
    background: 'rgba(0, 0, 0, 0.54)',
    zIndex: -1,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
}))

const Sidenav = ({ children }) => {
  const classes = useStyles()
  const { updateSettings } = useSettings()

  // Entries are gated on feature flags (`shouldRenderNavigation` reads the
  // store), so recompute whenever they're (re)fetched.
  const featureFlags = useSelector(allFlags)

  const filteredNavigations = useMemo(
    () =>
      navigations
        .filter((nav) => shouldRenderNavigation(nav))
        .map((nav) => {
          const children = nav.children?.filter((n) =>
            shouldRenderNavigation(n)
          )

          if (children?.length === 1) {
            // If we are dealing w/ a single child then no need for the dropdown
            return children[0]
          }

          return {
            ...nav,
            children,
          }
        }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [featureFlags]
  )

  const updateSidebarMode = (sidebarSettings) =>
    updateSettings({
      layoutSettings: {
        leftSidebar: {
          ...sidebarSettings,
        },
      },
    })

  return (
    <Fragment>
      <Scrollbar
        options={{ suppressScrollX: true }}
        className={clsx('relative px-4', classes.scrollable)}
      >
        {children}
        <MatxVerticalNav items={filteredNavigations} />
      </Scrollbar>

      <div
        onClick={() => updateSidebarMode({ mode: 'close' })}
        className={classes.sidenavMobileOverlay}
      />
    </Fragment>
  )
}

export default Sidenav
